import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './hooks/useAuth'
import { LoginPage } from './pages/LoginPage'
import { AdminSidebar } from './components/admin/AdminSidebar'
import { SchemaPage } from './pages/admin/SchemaPage'
import { InkorgPage } from './pages/admin/InkorgPage'
import { MedarbetarePage } from './pages/admin/MedarbetarePage'
import { LaddaUppPage } from './pages/admin/LaddaUppPage'
import { PasstyperPage } from './pages/admin/PasstyperPage'
import { SapPage } from './pages/admin/SapPage'
import { ManualPage } from './pages/admin/ManualPage'
import { AppSchema } from './pages/app/AppSchema'
import { BytLosenordForstaGangen } from './components/BytLosenordForstaGangen'
import { useState, useEffect } from 'react'
import { supabase } from './lib/supabase'
import './index.css'

function AppInner() {
  const { user, medarbetare, loading, isAdmin } = useAuth()
  const [inkorgsAntal, setInkorgsAntal] = useState(0)
  const [valdVy, setValdVy] = useState(() => localStorage.getItem('eon_vy') || null)

  useEffect(() => {
    if (isAdmin) {
      hamtaInkorgsAntal()
      const interval = setInterval(hamtaInkorgsAntal, 2000)
      return () => clearInterval(interval)
    }
  }, [isAdmin])

  function setValdVyMedSpara(vy) {
    if (vy) localStorage.setItem('eon_vy', vy)
    else localStorage.removeItem('eon_vy')
    setValdVy(vy)
  }

  // Rensa bara valdVy vid explicit utloggning, INTE vid sidladdning
  useEffect(() => {
    if (!user && !loading) {
      localStorage.removeItem('eon_vy')
      setValdVy(null)
    }
  }, [user, loading])

  async function hamtaInkorgsAntal() {
    const { data } = await supabase
      .from('ansokningar')
      .select('id')
      .eq('status', 'väntar')
      .eq('arkiverad_admin', false)
      .neq('typ', 'passandring_notis')
    setInkorgsAntal((data || []).length)
  }

  // Visa spinner medan auth och medarbetardata laddas
  if (loading || (user && !medarbetare)) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <div className="spinner" />
      </div>
    )
  }

  // Ej inloggad
  if (!user) return <LoginPage onValdVy={setValdVyMedSpara} />

  // Måste välja nytt lösenord innan man kommer vidare (gäller både admin och medarbetare)
  if (medarbetare?.maste_byta_losenord) return <BytLosenordForstaGangen />

  // Inloggad – hämta sparad vy
  const sparadVy = localStorage.getItem('eon_vy')

  // Icke-admin → alltid appen
  if (!isAdmin) return <AppSchema />

  // Admin utan sparad vy → visa val
  if (!sparadVy) return <LoginPage onValdVy={setValdVyMedSpara} />

  // Admin valde appen
  if (sparadVy === 'app') return <AppSchema />

  // Admin valde adminpanelen
  return (
    <div className="admin-shell">
      <AdminSidebar inkorgsAntal={inkorgsAntal} />
      <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <Routes>
          <Route path="/" element={<Navigate to="/admin/schema" replace />} />
          <Route path="/admin/schema" element={<SchemaPage />} />
          <Route path="/admin/inkorg" element={<InkorgPage />} />
          <Route path="/admin/medarbetare" element={<MedarbetarePage />} />
          <Route path="/admin/ladda-upp" element={<LaddaUppPage />} />
          <Route path="/admin/passtyper" element={<PasstyperPage />} />
          <Route path="/admin/sap" element={<SapPage />} />
          <Route path="/admin/manual" element={<ManualPage />} />
          <Route path="*" element={<Navigate to="/admin/schema" replace />} />
        </Routes>
      </div>
    </div>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppInner />
      </AuthProvider>
    </BrowserRouter>
  )
}
